var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Pagina não encontrada")]),_c('router-link',{staticClass:"btn btn-page-not-found",attrs:{"to":"/"}},[_vm._v("Voltar para Home")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }